/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  {
    url: "/dashboard",
    name: "Dashboard",
    slug: "dashboard",
    icon: "HomeIcon",
    i18n: "Inicio"
  },
  {
    url: "/clients",
    name: "Clientes",
    slug: "/clients",
    icon: "UsersIcon",
    i18n: "Clientes",
    new_item: "new-client"
  },
  // Viejo
  // {
  //   url: "/items",
  //   name: "Productos",
  //   slug: "/items",
  //   icon: "FileIcon",
  //   i18n: "Productos",
  //   new_item: "/new-item"
  // },
  // Nuevo
  {
    url: null,
    name: "Productos",
    slug: "productos",
    icon: "FileIcon",
    i18n: "Productos",
    submenu: [
      {
        url: "/items",
        name: "Catálogo",
        slug: "/items",
        i18n: "Catálogo",
        new_item: "/new-item"
      },
      {
        url: "/categories",
        name: "Categorias",
        slug: "/categories",
        i18n: "Categorias"
      },
      {
        url: "/families",
        name: "Familias",
        slug: "/families",
        i18n: "Familias"
      },
      {
        url: "/brands",
        name: "Marcas",
        slug: "/brands",
        i18n: "Marcas"
      }
    ]
  },
  {
    url: null,
    name: "Inventarios",
    slug: "inventories",
    icon: "FileTextIcon",
    i18n: "Inventarios",
    submenu: [
      {
        url: "/inventory-providers",
        name: "Proveedores",
        slug: "/inventory-providers",
        i18n: "Proveedores"
      },
      {
        url: "/item-products",
        name: "Compras",
        slug: "/item-products",
        i18n: "Compras"
      }
    ]
  },
  {
    url: null,
    name: "Ventas",
    slug: "inventories",
    icon: "FileTextIcon",
    i18n: "Ventas",
    submenu: [
      {
        url: "/orders",
        name: "Pedidos",
        slug: "/orders",
        i18n: "Pedidos"
      },
      {
        url: "/invoices",
        name: "Facturación",
        slug: "/invoices",
        i18n: "Facturación",
        new_item: "/new-invoice"
      },
      {
        url: "/quotations",
        name: "Cotizaciones",
        slug: "/quotations",
        i18n: "Cotizaciones"
      },
      {
        url: "/web-orders",
        name: "Ordenes Web",
        slug: "/web-orders",
        i18n: "Ordenes Web"
      },
      {
        url: "/recurrings",
        name: "Facturas Recurrentes",
        slug: "/recurrings",
        i18n: "Facturas Recurrentes"
      }
    ]
  },
  {
    url: null,
    name: "Contabilidad",
    slug: "accounting",
    icon: "FileTextIcon",
    i18n: "Contabilidad",
    submenu: [
      {
        url: "/payments",
        name: "Pagos",
        slug: "/payments",
        i18n: "Pagos"
      },
      {
        url: "/expenses",
        name: "Gastos",
        slug: "/expenses",
        i18n: "Gastos"
      },
      {
        url: "/message-receptors",
        name: "Documentos-E",
        slug: "/message-receptors",
        i18n: "Documentos-E"
      }
    ]
  },
  // {
  //   url: null,
  //   name: "Inventarios",
  //   slug: "inventories",
  //   icon: "FileTextIcon",
  //   i18n: "Inventarios",
  //   submenu: [
  //     {
  //       url: "/inventory-providers",
  //       name: "Proveedores",
  //       slug: "/inventory-providers",
  //       i18n: "Proveedores"
  //     },
  //     {
  //       url: "/item-products",
  //       name: "Lista de inventarios",
  //       slug: "/item-products",
  //       i18n: "Lista de inventarios"
  //     },
  //     {
  //       url: "/brands",
  //       name: "Marcas",
  //       slug: "/brands",
  //       i18n: "Marcas"
  //     },
  //     {
  //       url: "/salespeople",
  //       name: "Vendedores",
  //       slug: "/salespeople",
  //       i18n: "Vendedores"
  //     },
  //     {
  //       url: "/payment-forms",
  //       name: "Medios de pago",
  //       slug: "/payment-forms",
  //       i18n: "Medios de pago"
  //     }
  //   ]
  // },
  {
    header: " ",
    i18n: " "
  },
  // Viejo
  // {
  //   url: "/quotations",
  //   name: "Proformas",
  //   slug: "/quotations",
  //   icon: "FileTextIcon",
  //   i18n: "Proformas",
  //   new_item: "/new-quotation"
  // },

  // {
  //   url: "/recurrings",
  //   name: "Facturas recurrentes",
  //   slug: "/recurrings",
  //   icon: "FileTextIcon",
  //   i18n: "Facturas recurrentes"
  // },
  // Viejo
  // {
  //   url: "/invoices",
  //   name: "Facturas",
  //   slug: "/invoices",
  //   icon: "TagIcon",
  //   i18n: "Facturas",
  //   new_item: "/new-invoice"
  // },
  // {
  //   url: "/tickets",
  //   name: "Tiquetes",
  //   slug: "/tickets",
  //   icon: "FileTextIcon",
  //   i18n: "Tiquetes",
  //   new_item: "/new-ticket"
  // },
  {
    url: "/notes",
    name: "Notas",
    slug: "/notes",
    icon: "FileTextIcon",
    i18n: "Notas"
  },
  {
    url: null,
    name: "Simplificado",
    slug: "simples",
    icon: "FileTextIcon",
    i18n: "Simplificado",
    submenu: [
      {
        url: "/simples",
        name: "Emitidos",
        slug: "/simples",
        i18n: "Emitidos"
      },
      {
        url: "/providers",
        name: "Proveedores",
        slug: "/providers",
        i18n: "Proveedores"
      }
    ]
  },
  {
    header: " ",
    i18n: " "
  },
  // {
  //   url: "/message-receptors",
  //   name: "Recepción Documentos",
  //   slug: "/message-receptors",
  //   icon: "FileTextIcon",
  //   i18n: "Recepción Documentos",
  //   new_item: "new-message-receptor"
  // },
  // {
  //   url: "/payments",
  //   name: "Pagos",
  //   slug: "/payments",
  //   icon: "CreditCardIcon",
  //   i18n: "Pagos"
  // },
  // {
  //   url: "/expenses",
  //   name: "Gastos",
  //   slug: "/expenses",
  //   icon: "HeartIcon",
  //   i18n: "Gastos"
  // },
  {
    url: null,
    name: "Reportes",
    slug: "reports",
    icon: "ActivityIcon",
    i18n: "Reportes",
    submenu: [
      // Viejo
      // {
      //   url: "/report-tickets",
      //   name: "Tiquetes",
      //   slug: "/report-tickets",
      //   i18n: "Tiquetes"
      // },
      // {
      //   url: "/report-invoices",
      //   name: "Facturas",
      //   slug: "/report-invoices",
      //   i18n: "Facturas"
      // },
      // {
      //   url: "/report-notes",
      //   name: "Notas",
      //   slug: "/report-notes",
      //   i18n: "Notas"
      // }
      // Nuevo
      {
        url: "/report-expenses",
        name: "Gastos",
        slug: "/report-expenses",
        i18n: "Gastos"
      },
      {
        url: "/report-items",
        name: "Productos",
        slug: "/report-items",
        i18n: "Productos"
      },
      {
        url: "/report-item-products",
        name: "Inventarios",
        slug: "/report-item-products",
        i18n: "Inventarios"
      },
      {
        url: "/report-sales",
        name: "Vendedores",
        slug: "/report-sales",
        i18n: "Vendedores"
      },
      {
        url: "/report-document-receptions",
        name: "Documentos-E",
        slug: "/report-document-receptions",
        i18n: "Documentos-E"
      },
      {
        url: "/report-close-boxes",
        name: "Cierre de Caja",
        slug: "/report-close-boxes",
        i18n: "Cierre de Caja"
      }
      // {
      //   url: "/report-expenses",
      //   name: "Gastos",
      //   slug: "/report-expenses",
      //   i18n: "Gastos"
      // },
      // {
      //   url: "/report-items",
      //   name: "Productos",
      //   slug: "/report-items",
      //   i18n: "Productos"
      // },
      // {
      //   url: "/report-purchases",
      //   name: "Compras",
      //   slug: "/report-purchases",
      //   i18n: "Compras"
      // },
      // {
      //   url: "/report-document-receptions",
      //   name: "Recep. Documentos",
      //   slug: "/report-document-receptions",
      //   i18n: "Recep. Documentos"
      // },
      // {
      //   url: "/report-item-products",
      //   name: "Inventarios",
      //   slug: "/report-item-products",
      //   i18n: "Inventarios"
      // }
    ]
  },
  {
    header: " ",
    i18n: " "
  },
  // Nuevo
  {
    url: null,
    name: "Utilidades",
    slug: "utilities",
    icon: "FileTextIcon",
    i18n: "Utilidades",
    submenu: [
      {
        url: "/labels",
        name: "Etiquetas",
        slug: "/labels",
        i18n: "Etiquetas"
      },
      {
        url: "/bulk-load",
        name: "Cargas Masivas",
        slug: "/bulk-load",
        i18n: "Cargas Masivas"
      }
    ]
  },
  {
    url: null,
    name: "Configuraciones",
    slug: "config",
    icon: "SlidersIcon",
    i18n: "Configuraciones",
    submenu: [
      {
        url: "/salespeople",
        name: "Vendedores",
        slug: "/salespeople",
        i18n: "Vendedores"
      },
      {
        url: "/payment-forms",
        name: "Medios de pago",
        slug: "/payment-forms",
        i18n: "Medios de pago"
      },
      {
        url: "/companies",
        name: "Mis compañias",
        slug: "/companies",
        icon: "BoxIcon",
        i18n: "Mis compañias"
      },
    ]
  },
  // fin
  // {
  //   url: "/companies",
  //   name: "Mis compañias",
  //   slug: "/companies",
  //   icon: "BoxIcon",
  //   i18n: "Mis compañias"
  // },
  {
    url: null,
    name: "Administrador",
    slug: "administrator",
    icon: "ArchiveIcon",
    i18n: "Administrador",
    submenu: [
      {
        url: "/users",
        name: "Usuarios",
        slug: "/users",
        i18n: "Usuarios"
      },
      {
        url: "/all-companies",
        name: "Todas compañias",
        slug: "/all-companies",
        i18n: "Todas compañias"
      },
      {
        url: "/assign-company",
        name: "Asignar compañia",
        slug: "/assign-company",
        i18n: "Asignar compañia"
      },
      {
        url: "/advertisement",
        name: "Anuncio",
        slug: "/advertisement",
        i18n: "Anuncio"
      }
    ]
  }
];
